import { ArrowRight } from "lucide-react";
import { IMAGENES } from "@/constants/site";
import { Reveal } from "@/components/Reveal";
import { scrollToSection } from "@/lib/scroll";

export const Artesania = () => (
  <section id="nosotros" data-testid="artesania-section" className="py-20 sm:py-28 lg:py-32">
    <div className="mx-auto grid max-w-7xl items-center gap-16 px-4 sm:px-8 lg:grid-cols-2 lg:gap-20 lg:px-12">
      <Reveal>
        <p className="flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.3em] text-cafe">
          <span aria-hidden className="h-px w-9 bg-cafe/60" />
          Nuestra artesanía
        </p>
        <h2 className="mt-6 font-serif text-3xl leading-[1.14] tracking-tight text-tinta sm:text-4xl lg:text-[2.9rem]">
          Hecho a mano.{" "}
          <em className="font-garamond font-medium italic text-cafe">Hecho cada día.</em>
          <br />
          Hecho para disfrutar.
        </h2>
        <p className="mt-8 max-w-xl text-base leading-relaxed text-tinta/70 sm:text-lg">
          En Rawan no creemos en las prisas. Creemos en el tiempo que la masa necesita
          para respirar, en el crujido perfecto de una buena corteza y en el aroma del
          producto recién hecho.
        </p>
        <p className="mt-5 max-w-xl text-base leading-relaxed text-tinta/70 sm:text-lg">
          Trabajamos con procesos tradicionales, ingredientes seleccionados y una sola
          regla: elaborar cada día, para que lo que pruebas llegue siempre fresco a tu mesa.
        </p>
        <button
          data-testid="artesania-products-link"
          onClick={() => scrollToSection("#productos")}
          className="group mt-10 inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.18em] text-chocolate"
        >
          Descubre nuestros productos
          <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" />
        </button>
      </Reveal>

      <Reveal delay={0.15} className="relative">
        <div className="relative overflow-hidden rounded-[2rem] shadow-[0_30px_60px_rgba(58,36,24,0.18)]">
          <img
            src={IMAGENES.artesania}
            alt="Manos amasando la masa a mano en el obrador"
            loading="lazy"
            className="h-[420px] w-full object-cover lg:h-[560px]"
            data-zoomable
          />
        </div>
        <div className="absolute -bottom-10 right-4 hidden w-44 overflow-hidden rounded-2xl border-4 border-fondo shadow-xl sm:block lg:right-[-1.5rem]">
          <img
            src={IMAGENES.artesaniaDetalle}
            alt="Pan artesanal en bolsa de papel"
            loading="lazy"
            className="h-56 w-full object-cover"
          />
        </div>
        <span className="absolute top-5 left-5 rounded-full bg-crema/95 px-4 py-2 text-xs font-semibold uppercase tracking-[0.2em] text-chocolate backdrop-blur">
          Elaboración artesanal
        </span>
      </Reveal>
    </div>
  </section>
);

export default Artesania;
